import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";

export const kymw1406Handlers = [
  http.post(PlessService.SERVICE.getGoodsInfoList.url, () => {
    return HttpResponse.json(getGoodsInfoList);
  }),
  // http.post(PlessService.SERVICE.updateGoodsInfo.url, () => {
  //   return HttpResponse.json({ status: 'ok', message: '処理完了' });
  // }),
  // http.post<unknown, {
  //   data: {
  //     search: {
  //       CrossMulti: {
  //         parameter: { OrderCode: string, MediumType: string; },
  //         combination: { PCode: string, Priority: string; }[];
  //       };
  //     };
  //   };
  // }>
  //   (PlessService.SERVICE.getCrossMulti.url, async ({ request }) => {
  //     const { parameter: { OrderCode, MediumType }, combination } = (await request.json()).data.search.CrossMulti;
  //     return HttpResponse.json(getCrossMulti(OrderCode, MediumType, combination));
  //   }),
  // http.post(PlessService.SERVICE.KYMW14getPage.url, () => {
  //   return HttpResponse.json(getPage);
  // }),
];

const getGoodsInfoList = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": {
      "GoodsInfo": {
        "Record": [
          {
            "OrderNumSeqNo": "10",
            "PCode": "P2667277",
            "ItemCode": "4390423",
            "GuideGoodsName": "炭火やきとりもも串（しょうゆだれ）",
            "GuideStandardName": "６本入（１６２ｇ）",
            "ThisTimeSupplyPrice": "468",
            "OrderNum": "001",
            "ListingGoodsName": "",
            "BuyerComment": "表紙特１　よりどり１０％オフ",
            "GoodsExplanation": "若鶏もも肉のしょうゆだれのやきとり。炭火で香ばしく焼き上げました。",
            "CatchCopy": "",
            "RecommendComment": "★焼き鳥部門２位★",
            "ConvenienceInfoSiege": "",
            "ConvenienceInfoGoods": "",
            "ConvenienceInfoOther": "",
            "ConvenienceInfoEFriend": "",
            "ConvenienceInfoSize": "",
            "HandleWithCare": "",
            "AgeInformation":"月齢情報",
            "PopularProductInformation":"人気商品情報",
            "HealthCareInformation":"健康管理情報",
            "IngredientInformation":"成分情報",
            "WaterAbsorption":"吸水量",
            "MealKitEstimatedCookingTime":"調理時間の目安",
            "MealKitPortionInformation":"○人前情報",
            "MealKitIngredients":"材料",
            "MealKitItemsPreparedHome":"ご家庭で用意いただくもの"
          },
          {
            "OrderNumSeqNo": "20",
            "PCode": "P2191393",
            "ItemCode": "2191393",
            "GuideGoodsName": "産直茨城コシヒカリ",
            "GuideStandardName": "５ｋｇ",
            "ThisTimeSupplyPrice": "1680",
            "OrderNum": "",
            "ListingGoodsName": "",
            "BuyerComment": "表紙　新米（い）",
            "GoodsExplanation": "２３年産米。茨城県産コシヒカリ使用。",
            "CatchCopy": "",
            "RecommendComment": "",
            "ConvenienceInfoSiege": "",
            "ConvenienceInfoGoods": "",
            "ConvenienceInfoOther": "",
            "ConvenienceInfoEFriend": "",
            "ConvenienceInfoSize": "",
            "HandleWithCare": "",
            "AgeInformation":"月齢情報",
            "PopularProductInformation":"人気商品情報",
            "HealthCareInformation":"健康管理情報",
            "IngredientInformation":"成分情報",
            "WaterAbsorption":"吸水量",
            "MealKitEstimatedCookingTime":"調理時間の目安",
            "MealKitPortionInformation":"○人前情報",
            "MealKitIngredients":"材料",
            "MealKitItemsPreparedHome":"ご家庭で用意いただくもの"
          }
        ]
      },
      "ListingInfo": {
        "ListingPatternID": "",
        "ListingPCode": ""
      },
      "KomaInfo": {
        "KomaComment": "",
        "KomaPatternDiv": "00",
        ValueKomaComment: "価値コマコメントA"
      },
      CrossMultiInfo: {
        OrderCode: '',
        MediumType: '',
        CrossInfo: {
          CrossCode: '12345678',
          GoodsExplanation: 'クロス設定情報商品説明文',
          CatchCopy: 'クロス設定情報キャッチコピー'
        },
        MultiInfo: {
          MultiCode: '12345678',
          GoodsExplanation: 'マルチ設定情報商品説明文',
          CatchCopy: 'マルチ設定情報キャッチコピー'
        }
      }
    }
  }
};

const getCrossMulti = (
  orderCode: string,
  mediumType: string,
  combination: { PCode: string, Priority: string; }[]) => {
  if (combination.length <= 1) {
    return {
      status: "ok",
      message: "処理完了",
      result: {
        obj: {
          CrossMultiInfo: {
            OrderCode: orderCode,
            MediumType: mediumType,
            CrossInfo: "",
            MultiInfo: ""
          }
        }
      }
    };
  }
  return {
    status: "ok",
    message: "処理完了",
    result: {
      obj: {
        CrossMultiInfo: {
          OrderCode: orderCode,
          MediumType: mediumType,
          CrossInfo: {
            CrossCode: '22222222',
            GoodsExplanation: '商品説明文2',
            CatchCopy: 'キャッチコピー2'
          },
          MultiInfo: {
            MultiCode: '33333333',
            GoodsExplanation: '商品説明文3',
            CatchCopy: 'キャッチコピー3'
          }
        }
      }
    }
  };
};

const getPage = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": {
      "PageInfo": {
        "PageID": 2542110,
        "PageNum": 2,
        "TemplateName": "食品（５×７）",
        "PositionX": 0.0,
        "PositionY": 0.0,
        "SizeW": 257.5,
        "SizeH": 350.0,
        "DivX": 5,
        "DivY": 7,
        "SectionInfo": [
          {
            "SectionID": 2603689,
            "PositionX": 0.0,
            "PositionY": 0.0,
            "SizeW": 1.0,
            "SizeH": 1.0,
            "DivX": 5,
            "DivY": 7,
            "KomaInfo": [
              {
                "KomaID": 43983808,
                "PositionX": 0.5,
                "PositionY": 0.0,
                "SizeW": 0.25,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "Ｗ跨親",
                    "OrderNumSeqNo": 30,
                    "Priority": 1,
                    "GuideGoodsName": "無着色ひとくち辛子明太子（切子）",
                    "GuideStandardName": "１００ｇ",
                    "MakerName": "マルキユー食品",
                    "ThisTimeSupplyPrice": 380,
                    "OrderNum": "",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2665011"
                  },

                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_600/P2665011A_01.png?20250220155651",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_600/P2665011B_01.png?20250220155651",
                    "ShowSeq": 2
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_600/P2665011C_01.png?20250220155651",
                    "ShowSeq": 3
                  }
                ]
              },
              {
                "KomaID": 43983809,
                "PositionX": 0.5,
                "PositionY": 0.214285714,
                "SizeW": 0.25,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 60,
                    "Priority": 1,
                    "GuideGoodsName": "ぱくぱくオイッ！キムチ",
                    "GuideStandardName": "１５０ｇ",
                    "MakerName": "ピックルスコーポレーション",
                    "ThisTimeSupplyPrice": 218,
                    "OrderNum": "",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2197006"
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_056/P2197006A_01.png?20250220155651",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_056/P2197006E_01.png?20250220155651",
                    "ShowSeq": 2
                  }
                ]
              },
              {
                "KomaID": 43983810,
                "PositionX": 0.0,
                "PositionY": 0.214285714,
                "SizeW": 0.25,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 40,
                    "Priority": 1,
                    "GuideGoodsName": "あさり生姜煮",
                    "GuideStandardName": "１１０ｇ",
                    "MakerName": "佐々商店",
                    "ThisTimeSupplyPrice": 308,
                    "OrderNum": "",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2656087"
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_569/P2656087A_01.png?20250220155651",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_569/P2656087C_01.png?20250220155651",
                    "ShowSeq": 2
                  }
                ]
              },
              {
                "KomaID": 43983811,
                "PositionX": 0.25,
                "PositionY": 0.428571429,
                "SizeW": 0.25,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 80,
                    "Priority": 1,
                    "GuideGoodsName": "長野県産うす塩なめ茸",
                    "GuideStandardName": "１２０ｇ（固形分６０％）",
                    "MakerName": "長野興農",
                    "ThisTimeSupplyPrice": 120,
                    "OrderNum": "",
                    "PricePattern": "1",
                    "EdlpDiv": "1",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2650537"
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_548/P2650537A_01.png?20250220155651",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_548/P2650537C_01.png?20250220155651",
                    "ShowSeq": 2
                  }
                ]
              },
              {
                "KomaID": 43983812,
                "PositionX": 0.5,
                "PositionY": 0.428571429,
                "SizeW": 0.25,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 90,
                    "Priority": 1,
                    "GuideGoodsName": "鶏そぼろ（国産鶏ささみ肉使用）",
                    "GuideStandardName": "８０ｇ",
                    "MakerName": "ハチカン",
                    "ThisTimeSupplyPrice": 278,
                    "OrderNum": "",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2643866"
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_527/P2643866A_01.png?20250220155651",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_527/P2643866C_02.png?20250220155651",
                    "ShowSeq": 2
                  }
                ]
              },
              {
                "KomaID": 43983813,
                "PositionX": 0.75,
                "PositionY": 0.428571429,
                "SizeW": 0.25,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 100,
                    "Priority": 1,
                    "GuideGoodsName": "国産具材のきんぴら風ごぼう飯の素",
                    "GuideStandardName": "３合用　２３０ｇ",
                    "MakerName": "アーベストフーズ",
                    "ThisTimeSupplyPrice": 328,
                    "OrderNum": "",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2601630"
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_360/P2601630A_01.png?20250220155651",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_368/P2601630C_02.png?20250220155651",
                    "ShowSeq": 2
                  }
                ]
              },
              {
                "KomaID": 43983814,
                "PositionX": 0.25,
                "PositionY": 0.0,
                "SizeW": 0.25,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 20,
                    "Priority": 1,
                    "GuideGoodsName": "卓上朝食のり緑（味のり）",
                    "GuideStandardName": "８切４４枚×２",
                    "MakerName": "白子のり",
                    "ThisTimeSupplyPrice": 698,
                    "OrderNum": "",
                    "PricePattern": "2",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2064618"
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_047/P2064618A_02.png?20250220155651",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_488/P2064618C_01.png?20250220155651",
                    "ShowSeq": 2
                  }
                ]
              },
              {
                "KomaID": 43983815,
                "PositionX": 0.25,
                "PositionY": 0.214285714,
                "SizeW": 0.25,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 50,
                    "Priority": 1,
                    "GuideGoodsName": "おまめ亭　きんとき豆",
                    "GuideStandardName": "９５ｇ×２",
                    "MakerName": "くらこん",
                    "ThisTimeSupplyPrice": 188,
                    "OrderNum": "",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2625904"
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_455/P2625904A_01.png?20250220155651",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_473/P2625904C_02.png?20250220155651",
                    "ShowSeq": 2
                  }
                ]
              },
              {
                "KomaID": 43983816,
                "PositionX": 0.0,
                "PositionY": 0.0,
                "SizeW": 0.25,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 10,
                    "Priority": 1,
                    "GuideGoodsName": "刻み昆布",
                    "GuideStandardName": "２２ｇ×２袋",
                    "MakerName": "日東海藻",
                    "ThisTimeSupplyPrice": 318,
                    "OrderNum": "",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2608136"
                  }, {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 200,
                    "Priority": 2,
                    "GuideGoodsName": "ぱくぱくオイッ！キムチ",
                    "GuideStandardName": "１５０ｇ",
                    "MakerName": "ピックルスコーポレーション",
                    "ThisTimeSupplyPrice": 218,
                    "OrderNum": "",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2197006"
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_390/P2608136A_01.png?20250220155651",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_390/P2608136C_01.png?20250220155651",
                    "ShowSeq": 2
                  }
                ]
              },
              {
                "KomaID": 43983817,
                "PositionX": 0.0,
                "PositionY": 0.428571429,
                "SizeW": 0.25,
                "SizeH": 0.214285714,
                "PromotionName": "",
                "LayoutInfo": [
                  {
                    "MultiPublishString": "",
                    "OrderNumSeqNo": 70,
                    "Priority": 1,
                    "GuideGoodsName": "瓶詰ごはんのおともセット",
                    "GuideStandardName": "１セット",
                    "MakerName": "",
                    "ThisTimeSupplyPrice": 688,
                    "OrderNum": "",
                    "PricePattern": "1",
                    "EdlpDiv": "0",
                    "ReceiptSOrderCode": "",
                    "StartOrderCode": "",
                    "OrderNum6Digits": "",
                    "ItemCode": "",
                    "OrderGoodsFlg": "01",
                    "PCode": "P2674941"
                  }
                ],
                "ImageInfo": [
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_548/P2650537A_01.png?20250220155651",
                    "ShowSeq": 1
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_527/P2643866A_01.png?20250220155651",
                    "ShowSeq": 2
                  },
                  {
                    "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_360/P2601630A_01.png?20250220155651",
                    "ShowSeq": 3
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
};